<template>
  <div class="page-width-warpper">
    <div class="news-warpper">
      <div style="width: 280px">
        <div>
          <Wapper
            :title="title"
            :more="Object.keys(moreListPath).includes(code)"
            @more="$router.push(moreListPath[code])"
          >
            <ul class="news">
              <li v-for="(item, i) in hotList" :key="i" @click="toDetail(item)">
                <p>{{ item.title }}</p>
              </li>
            </ul>
          </Wapper>
        </div>
      </div>
      <div style="flex: 1">
        <div class="newsDetail">
          <div class="title">{{ pageData.title }}</div>
          <div class="time">
            时间：{{ pageData.createTime }} 点击：{{ pageData.cmsViewNum }}次
          </div>
          <div class="info" v-if="!!pageData.content">
            <div v-html="pageData.content"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Wapper from "./home/components/Wapper.vue";
import { pageByCode, newsDetail } from "@/api/index";

export default {
  name: "NewsDetail",
  components: {
    Wapper,
  },
  data() {
    return {
      hotList: [],
      pageData: {},
      moreListPath: {
        news: "/imgs",
      },
      title: "热点内容",
      code: "committee_information",
      isFormHome: false,
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(val) {
        this.getData(val.query.id);
      },
    },
  },
  created() {
    if (this.$route.query.title) {
      this.title = `${this.$route.query.title}`;
    }
    if (this.$route.query.code) {
      this.code = `${this.$route.query.code}`;
    }
    this.isFormHome = !!this.$route.query.home;
    this.getData(this.$route.query.id);
    pageByCode({ pageNum: 1, pageSize: 10, code: this.code }).then((res) => {
      this.hotList = res.data && res.data.records;
    });
  },
  methods: {
    getData(id) {
      newsDetail(id).then((res) => {
        this.pageData = res.data;
        if (this.pageData.content.indexOf("<table") !== -1) return;
        this.pageData.content = this.pageData.content.replace(
          /\t/g,
          "<span style='padding-left:1em;'></span>"
        );
      });
    },
    toDetail(item) {
      this.$router.push(
        `/newsDetail?id=${item.id}&code=${this.code}&title=${this.title}`
      );
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/variables.scss"; // global css
.news-warpper {
  display: flex;
  padding: 12px 0;
  .news {
    margin-top: 6px;
    li {
      display: flex;
      justify-content: space-between;
      line-height: 24px;
      font-size: 12px;
      position: relative;
      padding-left: 10px;
      &::before {
        content: "";
        position: absolute;
        left: 2px;
        top: 50%;
        transform: translateY(-50%);
        width: 3px;
        height: 3px;
        border-radius: 50%;
        background: #555;
      }
      p {
        flex: 1;
        color: #555;
        cursor: pointer;
        @include clamp(1);
        &:hover {
          color: $main-color;
          text-decoration: underline;
        }
      }
      span {
        color: #888;
        margin-left: 10px;
      }
    }
  }
}
.newsDetail {
  border: 1px solid #ddd;
  margin-left: 12px;
  .title {
    text-align: center;
    font-size: 16px;
    color: $main-color;
    font-weight: bold;
    padding: 20px 20px 0;
  }
  .time {
    text-align: center;
    color: #666;
    font-size: 12px;
    padding: 10px 0;
  }
  .info {
    padding: 5px 10px;
    // white-space: pre;
    // div {
    //   white-space: pre;
    // }
    ::v-deep a {
      text-decoration: underline;
      color: #0000ee;
    }

    ::v-deep img {
      max-width: 100%;
    }
  }
}
</style>
